/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Toast_Upload_SuccessInputs */

const es_settings_files_toast_upload_success = /** @type {(inputs: Settings_Files_Toast_Upload_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivos subidos`)
};

const en_settings_files_toast_upload_success = /** @type {(inputs: Settings_Files_Toast_Upload_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Files uploaded`)
};

/**
* | output |
* | --- |
* | "Files uploaded" |
*
* @param {Settings_Files_Toast_Upload_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_toast_upload_success = /** @type {((inputs?: Settings_Files_Toast_Upload_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Toast_Upload_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_toast_upload_success(inputs)
	return en_settings_files_toast_upload_success(inputs)
});
export { settings_files_toast_upload_success as "settings.files.toast.upload_success" }